import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import AppTemplate from '@/app/shared/ui/templates/AppTemplate.vue';
import { computed, ref, reactive, inject } from 'vue';
import rules from '@/app/shared/domain/data/rules';
import InputMoney from '@/app/shared/components/inputs/InputMoney.vue';
import InputProvidersAndCollaborators from '@/app/shared/components/inputs/InputProvidersAndCollaborators.vue';
import InputBank from '@/app/shared/components/inputs/InputBank.vue';
import InputNumber from '@/app/shared/components/inputs/InputNumber.vue';
import InputCostCenter from '@/app/shared/components/inputs/InputCostCenter.vue';
import BillToPay from '@/app/bill-to-pay/domain/interfaces/BillToPay';
import BillToPayRepository from '@/app/bill-to-pay/infrastructure/persistence/BillToPayRepository';
import InputBankCompanyList from '@/app/shared/components/inputs/InputBankCompanyList.vue';
import Tabs from '@/app/shared/components/Tabs.vue';
import { useForm } from '@/app/shared/ui/composable/form';
import StatusMapper from '@/app/shared/application/StatusMapper';
import useNotificationRepository from '@/app/shared/infrastructure/persistence/notification-repository';


export default /*#__PURE__*/_defineComponent({
  __name: 'BillToPayForm',
  props: ['id'],
  setup(__props) {

const props = __props;

const form = ref(null);

const repository = inject('billToPayRepository') as BillToPayRepository;
const notificationRepository = useNotificationRepository();

let billToPay = reactive({
    status: 'pending',
    values: {},
} as BillToPay);

const { pageTitle, submit, isEditPage } = useForm(
    props,
    billToPay,
    repository,
    form,
    'Editar conta a pagar',
    'Cadastrar conta a pagar',
    '/contas-a-pagar',
    '/contas-a-pagar',
);

const canApprove = computed(() => {
    return isEditPage.value ? billToPay.status !== 'payed' && billToPay.status !== 'approved' : false;
});

const canDispprove = computed(() => {
    return isEditPage.value ? billToPay.status !== 'payed' && billToPay.status !== 'disapproved' : false;
});

const canPay = computed(() => {
    return isEditPage.value ? billToPay.status === 'approved' : false;
});

const canMoveToPending = computed(() => {
    return isEditPage.value ? billToPay.status === 'payed' : false;
});

const handleApprove = async () => {
    await repository.approve(billToPay.id);

    notificationRepository.insert({
        id: Date.now().toString(),
        type: 'success',
        message: 'Conta aprovada com sucesso',
    });

    billToPay.status = 'approved';
};

const handleDispprove = async () => {
    await repository.disapprove(billToPay.id);

    notificationRepository.insert({
        id: Date.now().toString(),
        type: 'success',
        message: 'Conta reprovada com sucesso',
    });

    billToPay.status = 'disapproved';
};

const handlePay = async () => {
    await repository.pay(billToPay.id);

    notificationRepository.insert({
        id: Date.now().toString(),
        type: 'success',
        message: 'Conta paga com sucesso',
    });

    billToPay.status = 'payed';
};

const handleMoveToPending = async () => {
    await repository.moveToPending(billToPay.id);

    notificationRepository.insert({
        id: Date.now().toString(),
        type: 'success',
        message: 'Conta marcada como pendente',
    });

    billToPay.status = 'pending';
};

const tabItens = [
    {
        icon: 'mdi:mdi-book-open',
        key: 'main',
        title: 'Principal'
    },
    {
        icon: 'mdi:mdi-plus-circle-outline',
        key: 'add',
        title: 'Adicionais'
    },
];

return (_ctx: any,_cache: any) => {
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _directive_mask = _resolveDirective("mask")!

  return (_openBlock(), _createBlock(AppTemplate, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { justify: "space-around" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, { width: "100%" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_toolbar, { color: "surface" }, {
                append: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    onClick: _unref(submit),
                    "prepend-icon": "mdi:mdi-content-save",
                    color: "primary",
                    variant: "flat"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Salvar")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_toolbar_title, { class: "text-h6" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(pageTitle)), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_divider),
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_form, {
                    "lazy-validation": "",
                    ref_key: "form",
                    ref: form
                  }, {
                    default: _withCtx(() => [
                      _createVNode(Tabs, { itens: tabItens }, {
                        main: _withCtx(() => [
                          _createVNode(_component_v_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6"
                                      }, {
                                        default: _withCtx(() => [
                                          _withDirectives(_createVNode(_component_v_text_field, {
                                            label: "Data de emissão",
                                            rules: [_unref(rules).date, _unref(rules).required],
                                            modelValue: _unref(billToPay).issue_date,
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(billToPay).issue_date) = $event))
                                          }, null, 8, ["rules", "modelValue"]), [
                                            [_directive_mask, '##/##/####']
                                          ])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        md: "6"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_text_field, {
                                            rules: [_unref(rules).required],
                                            label: "Descrição",
                                            modelValue: _unref(billToPay).description,
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(billToPay).description) = $event))
                                          }, null, 8, ["rules", "modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(InputProvidersAndCollaborators, {
                                            rules: [_unref(rules).required],
                                            label: "Beneficiário",
                                            modelValue: _unref(billToPay).beneficiary,
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(billToPay).beneficiary) = $event))
                                          }, null, 8, ["rules", "modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6"
                                      }, {
                                        default: _withCtx(() => [
                                          _withDirectives(_createVNode(_component_v_text_field, {
                                            label: "Vencimento",
                                            rules: [_unref(rules).date, _unref(rules).required],
                                            modelValue: _unref(billToPay).due_date,
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(billToPay).due_date) = $event))
                                          }, null, 8, ["rules", "modelValue"]), [
                                            [_directive_mask, '##/##/####']
                                          ])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6"
                                      }, {
                                        default: _withCtx(() => [
                                          _withDirectives(_createVNode(_component_v_text_field, {
                                            label: "Vencimento real",
                                            rules: [_unref(rules).date, _unref(rules).required],
                                            modelValue: _unref(billToPay).real_due_date,
                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(billToPay).real_due_date) = $event))
                                          }, null, 8, ["rules", "modelValue"]), [
                                            [_directive_mask, '##/##/####']
                                          ])
                                        ]),
                                        _: 1
                                      }),
                                      (_unref(isEditPage))
                                        ? (_openBlock(), _createBlock(_component_v_col, {
                                            key: 0,
                                            cols: "12",
                                            sm: "6"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_text_field, {
                                                label: "Status",
                                                readonly: "",
                                                "model-value": _unref(StatusMapper).map(_unref(billToPay).status)
                                              }, null, 8, ["model-value"])
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(InputBankCompanyList, {
                                            rules: [_unref(rules).required],
                                            modelValue: _unref(billToPay).account_id,
                                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(billToPay).account_id) = $event))
                                          }, null, 8, ["rules", "modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_text_field, {
                                            label: "Observação",
                                            modelValue: _unref(billToPay).observations,
                                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(billToPay).observations) = $event))
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_divider, { class: "my-10" }),
                                  _createVNode(_component_v_row, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6",
                                        md: "4"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(InputMoney, {
                                            rules: [_unref(rules).required],
                                            label: "Valor do título",
                                            modelValue: _unref(billToPay).values.main,
                                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(billToPay).values.main) = $event))
                                          }, null, 8, ["rules", "modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6",
                                        md: "4"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(InputMoney, {
                                            label: "Acréscimo",
                                            modelValue: _unref(billToPay).values.add,
                                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(billToPay).values.add) = $event))
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6",
                                        md: "4"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(InputMoney, {
                                            label: "Iss",
                                            modelValue: _unref(billToPay).values.iss,
                                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(billToPay).values.iss) = $event))
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6",
                                        md: "4"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(InputMoney, {
                                            label: "Irrf",
                                            modelValue: _unref(billToPay).values.irrf,
                                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(billToPay).values.irrf) = $event))
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6",
                                        md: "4"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(InputMoney, {
                                            label: "Reajuste",
                                            modelValue: _unref(billToPay).values.readjustment,
                                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(billToPay).values.readjustment) = $event))
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6",
                                        md: "4"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(InputMoney, {
                                            label: "Correção",
                                            modelValue: _unref(billToPay).values.correction,
                                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(billToPay).values.correction) = $event))
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6",
                                        md: "4"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(InputMoney, {
                                            label: "Desconto",
                                            modelValue: _unref(billToPay).values.discount,
                                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(billToPay).values.discount) = $event))
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6",
                                        md: "4"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(InputMoney, {
                                            label: "Multa",
                                            modelValue: _unref(billToPay).values.assessment,
                                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(billToPay).values.assessment) = $event))
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6",
                                        md: "4"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(InputMoney, {
                                            label: "Juros",
                                            modelValue: _unref(billToPay).values.fees,
                                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(billToPay).values.fees) = $event))
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6",
                                        md: "4"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(InputMoney, {
                                            rules: [_unref(rules).required],
                                            label: "Saldo a pagar",
                                            modelValue: _unref(billToPay).values.balance_to_pay,
                                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(billToPay).values.balance_to_pay) = $event))
                                          }, null, 8, ["rules", "modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6",
                                        md: "4"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(InputMoney, {
                                            label: "Liquido baixado",
                                            modelValue: _unref(billToPay).values.net_payed,
                                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_unref(billToPay).values.net_payed) = $event))
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  (_unref(isEditPage))
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createVNode(_component_v_divider, { class: "my-10" }),
                                        _createVNode(_component_v_row, { class: "justify-center justify-sm-end" }, {
                                          default: _withCtx(() => [
                                            (_unref(canApprove))
                                              ? (_openBlock(), _createBlock(_component_v_col, {
                                                  key: 0,
                                                  cols: "6",
                                                  sm: "3",
                                                  class: "justify-center d-flex"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_btn, {
                                                      onClick: handleApprove,
                                                      "prepend-icon": "fa-solid fa-check",
                                                      color: "green"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode("Aprovar")
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                }))
                                              : _createCommentVNode("", true),
                                            (_unref(canDispprove))
                                              ? (_openBlock(), _createBlock(_component_v_col, {
                                                  key: 1,
                                                  cols: "6",
                                                  sm: "3",
                                                  class: "justify-center d-flex"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_btn, {
                                                      onClick: handleDispprove,
                                                      "prepend-icon": "fa-solid fa-xmark",
                                                      color: "red"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode("Reprovar")
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                }))
                                              : _createCommentVNode("", true),
                                            (_unref(canPay))
                                              ? (_openBlock(), _createBlock(_component_v_col, {
                                                  key: 2,
                                                  cols: "6",
                                                  sm: "3",
                                                  class: "justify-center d-flex"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_btn, {
                                                      onClick: handlePay,
                                                      "prepend-icon": "fa-solid fa-money-bill",
                                                      color: "primary"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode("Pagar")
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                }))
                                              : _createCommentVNode("", true),
                                            (_unref(canMoveToPending))
                                              ? (_openBlock(), _createBlock(_component_v_col, {
                                                  key: 3,
                                                  cols: "6",
                                                  sm: "3",
                                                  class: "justify-center d-flex"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_btn, {
                                                      onClick: handleMoveToPending,
                                                      "prepend-icon": "fa-solid fa-rotate-left",
                                                      color: "grey"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode("Estornar")
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                }))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 1
                                        })
                                      ], 64))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        add: _withCtx(() => [
                          _createVNode(_component_v_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, {
                                cols: "12",
                                sm: "6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field, {
                                    label: "Número do cheque",
                                    modelValue: _unref(billToPay).check_number,
                                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_unref(billToPay).check_number) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                sm: "6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(InputBank, {
                                    label: "Banco",
                                    modelValue: _unref(billToPay).check_code_bank,
                                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_unref(billToPay).check_code_bank) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                sm: "6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field, {
                                    label: "Agência cheque + dígito",
                                    modelValue: _unref(billToPay).check_agency,
                                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_unref(billToPay).check_agency) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                sm: "6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field, {
                                    label: "Conta cheque + dígito",
                                    modelValue: _unref(billToPay).check_account,
                                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_unref(billToPay).check_account) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                sm: "6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_switch, {
                                    modelValue: _unref(billToPay).generates_dirf,
                                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_unref(billToPay).generates_dirf) = $event)),
                                    inset: "",
                                    color: "primary",
                                    label: "Gera dirf"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                sm: "6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field, {
                                    label: "Código de retenção",
                                    modelValue: _unref(billToPay).retention_code,
                                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_unref(billToPay).retention_code) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                sm: "6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(InputMoney, {
                                    label: "Inss retido",
                                    modelValue: _unref(billToPay).retention_inss,
                                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_unref(billToPay).retention_inss) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                sm: "6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field, {
                                    label: "Id darf",
                                    modelValue: _unref(billToPay).darf_id,
                                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_unref(billToPay).darf_id) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                sm: "6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(InputMoney, {
                                    label: "Taxa de permanência",
                                    modelValue: _unref(billToPay).permanence_tax,
                                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_unref(billToPay).permanence_tax) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                sm: "6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(InputNumber, {
                                    label: "% de juros",
                                    modelValue: _unref(billToPay).percent_fees,
                                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_unref(billToPay).percent_fees) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                sm: "6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field, {
                                    label: "Número do borderô",
                                    modelValue: _unref(billToPay).bordero_number,
                                    "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_unref(billToPay).bordero_number) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                sm: "6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(InputCostCenter, {
                                    modelValue: _unref(billToPay).cost_center_id,
                                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_unref(billToPay).cost_center_id) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                sm: "6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field, {
                                    label: "Classificação",
                                    modelValue: _unref(billToPay).classification,
                                    "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_unref(billToPay).classification) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                sm: "6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field, {
                                    label: "Rateio",
                                    modelValue: _unref(billToPay).apportionment,
                                    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_unref(billToPay).apportionment) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                sm: "6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field, {
                                    label: "Ocorrência cnab",
                                    modelValue: _unref(billToPay).cnab_occurrence,
                                    "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_unref(billToPay).cnab_occurrence) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                sm: "6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field, {
                                    label: "Id cnab",
                                    modelValue: _unref(billToPay).cnab_id,
                                    "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_unref(billToPay).cnab_id) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                sm: "6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field, {
                                    label: "Origem",
                                    modelValue: _unref(billToPay).origin,
                                    "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_unref(billToPay).origin) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                sm: "6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(InputMoney, {
                                    label: "Inss",
                                    modelValue: _unref(billToPay).inss_value,
                                    "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_unref(billToPay).inss_value) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                sm: "6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(InputNumber, {
                                    label: "Parcela inss",
                                    modelValue: _unref(billToPay).inss_installment,
                                    "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_unref(billToPay).inss_installment) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                sm: "6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field, {
                                    label: "Número de liquidação",
                                    modelValue: _unref(billToPay).liquidation_number,
                                    "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_unref(billToPay).liquidation_number) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 512)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})